import { defineQuery } from 'next-sanity'
import { imageFields, inlineCtaFields } from '../atoms'

export const careersTextBlockFields = `
  _id,
  _type,
  heading,
  subheading,
  mainText,
  buttonLink {
    ${inlineCtaFields}
  },
  fullWidthImage {
    ${imageFields}
  },
  variant,
  backgroundColor,
  decorativeShape
`

export const CAREERS_TEXT_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "careers-text-block"][0]{
    ${careersTextBlockFields}
  }
`)
